import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export default function MiddKitchen() {
    useEffect(() => {
        new Splide('.js-splide-masthead', {
            type: 'fade',
            drag: 'free',
            focus: 'right',
            perPage: 1,
            autoScroll: {
                speed: 1,
            },
            speed: 4e3,
            rewind: !0,
            updateOnMove: !0,
            autoplay: !0,
            interval: 6e3,
            pauseOnHover: !1,
            pauseOnFocus: !1,
            arrows: !1,
            pagination: !1
        }).mount();
    }, []);

    const [BookFromData, setBookFromData] = useState({
        action: 'DemonstrationSubmit',
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: ''
    });

    const [BookFromErrors, setBookFromErrors] = useState({
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: ''
    });

    const [catalouge, setCatalouge] = useState(''); // ✅ यहां पहले से डिक्लेयर है

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Clear error when user starts typing
        if (BookFromErrors[name]) {
            setBookFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateBookForm = () => {
        const errors = {};
        let isValid = true;

        if (!BookFromData.inputFullName.trim()) {
            errors.inputFullName = 'Full Name is required';
            isValid = false;
        }

        if (!BookFromData.inputNumber.trim()) {
            errors.inputNumber = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(BookFromData.inputNumber.replace(/\D/g, ''))) {
            errors.inputNumber = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!BookFromData.inputEmail.trim()) {
            errors.inputEmail = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BookFromData.inputEmail)) {
            errors.inputEmail = 'Please enter a valid email address';
            isValid = false;
        }

        if (!BookFromData.inputCity.trim()) {
            errors.inputCity = 'City is required';
            isValid = false;
        }

        setBookFromErrors(errors);
        return isValid;
    };

    const toastId = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const BookhandleSubmit = async (e) => {
        e.preventDefault();

        if (!validateBookForm()) {           
            return false;
        }

        setIsSubmitting(true);
        toastId.current = toast.loading("Please Wait...");

        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, BookFromData);

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setModalVisible(false);
                setBookFromData({
                    action: 'DemonstrationSubmit',
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: ''
                });
                setBookFromErrors({
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: ''
                });
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const [DownloadFromData, setDownloadFromData] = useState({
        action: 'DownloadBrochureSubmit',
        inputFullName1: '',
        inputNumber1: '',
        inputEmail1: '',
        companyName1: '',
        inputMessage1: '',
        brochure: ''
    });

    const [DownloadFromErrors, setDownloadFromErrors] = useState({
        inputFullName1: '',
        inputNumber1: '',
        inputEmail1: '',
        brochure: ''
    });
    const [isDownloadSubmitting, setIsDownloadSubmitting] = useState(false);

    const DownloadhandleChange = (e) => {
        const { name, value } = e.target;
        setDownloadFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (DownloadFromErrors[name]) {
            setDownloadFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateDownloadForm = () => {
        const errors = {};
        let isValid = true;

        if (!DownloadFromData.inputFullName1.trim()) {
            errors.inputFullName1 = 'Full Name is required';
            isValid = false;
        }

        if (!DownloadFromData.inputNumber1.trim()) {
            errors.inputNumber1 = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(DownloadFromData.inputNumber1.replace(/\D/g, ''))) {
            errors.inputNumber1 = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!DownloadFromData.inputEmail1.trim()) {
            errors.inputEmail1 = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(DownloadFromData.inputEmail1)) {
            errors.inputEmail1 = 'Please enter a valid email address';
            isValid = false;
        }
        if (!DownloadFromData.companyName1.trim()) {
            errors.companyName1 = 'Company Name is required';
            isValid = false;
        }

        if (!DownloadFromData.brochure) {
            errors.brochure = 'Please select a brochure';
            isValid = false;
        }
        if (!DownloadFromData.inputMessage1.trim()) {
            errors.inputMessage1 = 'City Name is required';
            isValid = false;
        }

        setDownloadFromErrors(errors);
        return isValid;
    };

    const DownloadhandleSubmit = async (e) => {
        e.preventDefault();

        if (!validateDownloadForm()) {
            return false;
        }

        setIsDownloadSubmitting(true);
        toastId.current = toast.loading("Please Wait...");

        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, DownloadFromData);

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setModalVisible(false);
                setDownloadFromData({
                    action: 'DownloadBrochureSubmit',
                    inputFullName1: '',
                    inputNumber1: '',
                    inputEmail1: '',
                    companyName1: '',
                    inputMessage1: '',
                    brochure: ''
                });
                setDownloadFromErrors({
                    inputFullName1: '',
                    inputNumber1: '',
                    inputEmail1: '',
                    brochure: ''
                });
                window.open(`${process.env.REACT_APP_APP_URL}/catalouge/assets/catalouge/${DownloadFromData.brochure}`, "_blank");
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsDownloadSubmitting(false);
        }
    };
    
    // ✅ यहां catalouge स्टेट को दोबारा डिक्लेयर नहीं किया गया है
    const ListCatalogueData = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, { action: 'ListCatalogue' });
            setCatalouge(response.data);
        } catch (error) {
            console.error('Error fetching Catalouge data:', error);
        }
    };

    const renderCatalouge = () => {
        if (!catalouge || !catalouge.data) return null;

        return catalouge.data.map(product => (
            <option value={product.pdf}>{product.name}</option>
        ));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const searchQuery = formData.get('search');
        navigate(`/products/search/${encodeURIComponent(searchQuery)}`);
    };

    const navigate = useNavigate();

    useEffect(() => {
        ListCatalogueData();
    }, []);

    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);

    const OpenTingleModal = (modeltype) => {
        if (modeltype) {
            setModalVisible(true);
            setModalType(modeltype);
        } else {
            setModalVisible(false);
        }
    }

    return (
        <>
            <ToastContainer />
        

           <section className="js-block-masthead section section--masthead advanced">
  <div className="section--masthead__top">

    {/* Background Layers */}
    <div
      className="js-parallax images images--middle"
      data-offset="-0.05"
      style={{ backgroundImage: 'url("assets/uploads/bckgnd--masthead-top-01.jpg")' }}
    ></div>

    <div
      className="js-parallax images images--back"
      data-offset="0.15"
      style={{ backgroundImage: 'url("assets/uploads/img--masthead-bckgnd-01.jpg")' }}
    ></div>

    {/* Slider */}
    <div
      className="js-splide-masthead js-parallax images images--front splide splide--masthead"
      data-offset="0.15"
      id="secondary-slider"
    >
      <div className="splide__track">
        <div className="splide__list">
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew4.webp")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew5.png")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew1.webp")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew2.webp")' }}></div>
          <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew3.webp")' }}></div>
          {/* <div className="splide__slide" style={{ backgroundImage: 'url("assets/uploads/middkitchen/slidernew1.webp")' }}></div> */}
        </div>
      </div>
    </div>

    {/* Top Content */}
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div >
              <img 
             src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/kitchenlogo1.jpg`}
              alt="About Midd=Kitchen"
              title="About Midd=Kitchen" style={{ height: '50px', marginBottom: '10px' }} />
            </div>
            <div className="wysiwyg">
              <p>
                Midd=Kitchen™ is a dedicated bakery equipment brand developed and marketed by <strong>Middleby Celfrost Innovations Pvt Ltd,</strong> created to support professional bakeries with equipment that delivers consistent results, controlled performance, and dependable operation.

              </p>
            </div>

            <div className="row g-2 mt-5">
              <div className="col-md-4">
                <Link className="btn btn--block" to="/products/brand/midd-kitchen">
                  <span>Our Product</span>
                  <span className="icon"></span>
                </Link>
              </div>

              <div className="col-md-8">
                <form
                  className="js-form-product-search"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                  method="GET"
                >
                  <label className="visually-hidden" htmlFor="s">
                    Search products
                  </label>
                  <div className="input-group">
                    <span className="icon">
                      <i className="fas fa-magnifying-glass"></i>
                    </span>
                    <input
                      className="form-control"
                      name="search"
                      type="text"
                      placeholder="Search products…"
                    />
                  </div>
                  <button className="visually-hidden" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  {/* ================= BOTTOM CONTENT (UPDATED FOR VERO) ================= */}
  <div className="section--masthead__bottom">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">

          <div className="wysiwyg text-center">

            <h2 className="primarycolor fw-bold mb-2">
             Bakery & Professional Kitchen Equipment

            </h2>

            {/* <p className="fw-semibold mb-3">
              Engineered in Spain. Backed by Middleby Celfrost India.
            </p> */}

            {/* <p className="mb-3">
              VERO is a professional coffee machine brand developed by
              <strong> Middleby Celfrost Innovations Pvt Ltd</strong>, created to
              meet the evolving needs of cafés, offices, bakeries, QSRs, and
              hospitality businesses across India.
            </p> */}

            <p className="mb-3">
             With a strong emphasis on stone-based deck ovens with steam, Midd=Kitchen™ is engineered for bakeries where heat behaviour, moisture control, and build quality directly influence product quality and baking consistency.

            </p>

            <p className="fw-semibold mb-4">
             	Built for professional baking. Designed for consistency. Supported by Middleby Celfrost India.

            </p>

            <p>
              <Link
                className="btn mx-2"
                to="/products/brand/midd-kitchen"
                // onClick={() => OpenTingleModal("freedemo")}
              >
                Explore Midd=Kitchen™
                <span className="icon"></span>
              </Link>

              <a
                className="btn btn--secondary mx-2"
                onClick={() => OpenTingleModal("freedemo")}
              >
                Talk to a Bakery Equipment Specialist
                <span className="icon"></span>
              </a>
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</section>

            
            <div className="section section--shadow top"></div>
            
           <section className="js-block-masthead section section--masthead advanced">
  <div
    className="section--masthead__bottom fadeinsec mt-3"
    id="next"
    style={{ marginTop: "-30px" }}
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">

        {/* LEFT IMAGE */}
        <div className="col-md-6 col-sm-12 mb-4 mb-md-0">
          <div className="wysiwyg text-center">
            <img
              className="w-100 box-shadow p-3 rounded-1 shadow automaticon border border-primary exp-img2"
              src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/slider2.png`}
              alt="About Midd=Kitchen"
              title="About Midd=Kitchen"
            />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="col-md-6 col-sm-12">
          <div className="wysiwyg">

            <h2 className="mb-3 primarycolor fw-bold">
              About Midd=Kitchen™
            </h2>

            <p className="mb-3">
              <strong>Midd=Kitchen™</strong> is developed with a clear focus on the
              requirements of professional bakery operations, where equipment
              performance plays a decisive role in product structure, crust
              quality, and batch uniformity.
            </p>

            <p className="mb-3">
              The brand concentrates on bakery-centric equipment, including
              deck ovens, dough preparation systems, and supporting machines
              that contribute to controlled baking environments and efficient
              production workflows. Every Midd=Kitchen™ product is designed to
              support stable operation, repeatable results, and long service
              life.
            </p>

            <p className="mb-0">
              By combining thoughtful engineering with practical design,
              Midd=Kitchen™ enables bakers to maintain process discipline while
              achieving consistent output across production cycles.
            </p>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>


<section className="section p-0 section1 bg-dark section--products m-0">
  <div className="w-98 p-0">
    <div className="row align-items-center">

      {/* LEFT CONTENT */}
      <div className="col-lg-6 section28">
        <div className="px-4 py-5">

          <h3 className="primarycolor h1 fw-bold mb-4">
            What Defines Midd=Kitchen™ Equipment
          </h3>

          <p className="text-dark fs-5 mb-3">
            Developed with direct inputs from professional bakers and application
            specialists within Middleby Celfrost.
          </p>

          <p className="text-dark fs-5 mb-4">
            Midd=Kitchen™ equipment is shaped by hands-on baking experience, where
            oven behaviour, dough response, and steam control are evaluated in real
            production environments. This approach ensures that every design and
            engineering decision directly supports consistent results, reliable
            output, and professional baking performance.
          </p>

          <p className="text-dark fw-semibold fs-5 mb-3">
            Midd=Kitchen™ equipment is defined by the qualities professional bakers
            value most:
          </p>

          <ul className="list-unstyled text-dark fs-5 mb-4">
            <li className="mb-2">✔ Solid, heavy-duty construction for commercial bakery environments</li>
            <li className="mb-2">✔ Stone baking decks for even heat storage and distribution</li>
            <li className="mb-2">✔ Integrated steam systems supporting oven spring and crust development</li>
            <li className="mb-2">✔ Stable and precise temperature control</li>
            <li className="mb-2">✔ Feature sets designed for consistency and ease of operation</li>
          </ul>

          <p className="text-dark fs-5 lh-base mb-0">
            These elements work together to support predictable performance and
            dependable baking results.
          </p>

        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div
        className="col-lg-6 p-0 aboutvisionimage"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img1.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "645px"
        }}
      ></div>

    </div>
  </div>
</section>


<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-98 p-0">
    <div className="row">

      {/* LEFT IMAGE */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img2.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      ></div>

      {/* RIGHT CONTENT */}
      <div className="col-lg-6 section28">
        <div className="px-3 mt-4 mb-2 pb-2">

          <h3 className="primarycolor h1 fw-bold">
            Why Professional Bakers Choose Midd=Kitchen™
          </h3>

          <p className="mt-3 fs-1-2 lh-base">
            Midd=Kitchen™ equipment is developed with direct inputs from
            professional bakers and application specialists within
            Middleby Celfrost—ensuring real-world baking performance.
          </p>

          {/* FEATURE LIST */}
          <ul className="list-unstyled mt-4 fs-1-2 lh-lg">

            <li className="pt-3">
              <span className="primarycolor fw-bold">Designed for Baking Performance</span>
              <br />
              Deck ovens engineered around dough behaviour under heat and steam,
              enabling consistent internal structure and uniform crust development.
            </li>

            <li className="pt-3">
              <span className="primarycolor fw-bold">Stone Decks with Integrated Steam</span>
              <br />
              Stone hearth baking with controlled steam supports strong oven spring,
              even heat transfer, balanced moisture retention, and uniform results
              across decks and trays.
            </li>

            <li className="pt-3">
              <span className="primarycolor fw-bold">Robust Build Quality</span>
              <br />
              Durable materials and proven construction methods ensure reliable
              operation in high-output commercial bakery environments.
            </li>

            <li className="pt-3">
              <span className="primarycolor fw-bold">Practical, Feature-Rich Design</span>
              <br />
              Controls and features are designed to maintain stable baking parameters,
              support operator confidence, and deliver consistent output across shifts.
            </li>

            <li className="pt-3">
              <span className="primarycolor fw-bold">Supported by Middleby Celfrost India</span>
              <br />
              Installation, commissioning, training, service, and spare parts
              availability are backed by Middleby Celfrost India’s nationwide
              service infrastructure.
            </li>

          </ul>

        </div>
      </div>

    </div>
  </div>
</section>


<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-98 p-0">
    <div className="row align-items-center">

      {/* LEFT CONTENT */}
      <div className="col-lg-6 section28">
        <div className="px-4 py-5">

          <h3 className="primarycolor h1 fw-bold mb-3">
            Core Bakery Equipment Portfolio
          </h3>

          <p className="fs-1-2 lh-base mb-4">
            Midd=Kitchen™ offers a focused portfolio of equipment designed to
            support professional bakery production—where consistency, control,
            and reliability are critical.
          </p>

          {/* STONE DECK OVENS */}
          <div className="mb-4">
            <h5 className="fw-semibold primarycolor mb-2">
              Stone-Based Deck Ovens
            </h5>
            <ul className="list-unstyled fs-1-2 lh-lg">
              <li>• Stone baking surfaces for consistent heat transfer</li>
              <li>• Integrated steam injection systems</li>
              <li>• Uniform temperature distribution</li>
              <li>• Ideal for breads, buns, loaves & specialty products</li>
            </ul>
          </div>

          {/* PIZZA OVENS */}
          <div className="mb-4">
            <h5 className="fw-semibold primarycolor mb-2">
              Pizza Ovens
            </h5>
            <ul className="list-unstyled fs-1-2 lh-lg">
              <li>• Stable high-temperature performance</li>
              <li>• Consistent baking results</li>
              <li>• Reliable output for bakery & foodservice use</li>
            </ul>
          </div>

          {/* MIXERS */}
          <div className="mb-4">
            <h5 className="fw-semibold primarycolor mb-2">
              Spiral Mixers
            </h5>
            <ul className="list-unstyled fs-1-2 lh-lg">
              <li>• Consistent and efficient dough mixing action</li>
              <li>• Strong mechanical construction</li>
              <li>• Suitable for professional bakery production volumes</li>
            </ul>
          </div>

          <div>
            <h5 className="fw-semibold primarycolor mb-2">
              Planetary Mixers
            </h5>
            <ul className="list-unstyled fs-1-2 lh-lg">
              <li>• Supports batters, creams, and doughs</li>
              <li>• Ideal for bakery and patisserie operations</li>
            </ul>
          </div>

        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img7.jpeg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight:"795px"
        }}
      ></div>

    </div>
  </div>
</section>

<section
  className="space-top space-extra-bottom background-image py-5"
  style={{ backgroundImage: 'url("assets/img/bg/sr-bg-1-1.png")' }}
>
  <div className="container">

    {/* SECTION TITLE */}
    <div className="row justify-content-center text-center mb-5">
      <div className="col-lg-8 col-xl-6">
        <div className="title-area">
          <h1 className="sec-subtitle primarycolor fontsizelrg">
            Extended Equipment Range
          </h1>
        </div>
      </div>
    </div>

    {/* CONTENT */}
    <div className="row justify-content-center mb-4">
      <div className="col-lg-10 text-center">
        <p className="fs-1-2 lh-base">
          In addition to core bakery equipment, Midd=Kitchen™ also offers
          solutions that support broader bakery and professional kitchen
          workflows, including:
        </p>
      </div>
    </div>

    {/* EQUIPMENT LIST */}
    <div className="row mt-4">

      {/* Bun Toasters */}
      <div className="col-md-3 col-lg-3 mb-4">
        <div className="service-style1 text-center h-100 p-4">
          <div className="service-icon mb-3 d-flex justify-content-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/toaster1.png`}
              alt="Bun Toasters"
              style={{ width: '180px', height: '200px', objectFit: 'contain' }}
            />
          </div>
          <h3 className="service-title h5 fonttitle">
            Bun Toasters
          </h3>
        </div>
      </div>

      {/* Waffle Machines */}
      <div className="col-md-3 col-lg-3 mb-4">
        <div className="service-style1 text-center h-100 p-4">
          <div className="service-icon mb-3 d-flex justify-content-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img14.png`}
              alt="Waffle Machines"
              style={{ width: '180px', height: '200px', objectFit: 'contain' }}
            />
          </div>
          <h3 className="service-title h5 fonttitle">
            Waffle Machines
          </h3>
        </div>
      </div>

      {/* Induction Cookers */}
      <div className="col-md-3 col-lg-3 mb-4">
        <div className="service-style1 text-center h-100 p-4">
          <div className="service-icon mb-3 d-flex justify-content-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/cooker.webp`}
              alt="Induction Cookers"
              style={{ width: '180px', height: '200px', objectFit: 'contain' }}
            />
          </div>
          <h3 className="service-title h5 fonttitle">
            Induction Cookers
          </h3>
        </div>
      </div>

      {/* Induction Fryers */}
      <div className="col-md-3 col-lg-3 mb-4">
        <div className="service-style1 text-center h-100 p-4">
          <div className="service-icon mb-3 d-flex justify-content-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/fryres.png`}
              alt="Induction Fryers"
              style={{ width: '180px', height: '200px', objectFit: 'contain' }}
            />
          </div>
          <h3 className="service-title h5 fonttitle">
            Induction Fryers
          </h3>
        </div>
      </div>

    </div>

    {/* FOOT NOTE */}
    <div className="row justify-content-center text-center mt-4">
      <div className="col-lg-8">
        <p className="mt-3 fs-1-2 lh-base">
          These products complement bakery operations while maintaining the
          same standards of reliability, usability, and performance.
        </p>
      </div>
    </div>

  </div>
</section>


<section className="section section--products bg-grey py-5">
  <div className="container">

    {/* SECTION TITLE */}
    <div className="row justify-content-center text-center mb-4">
      <div className="col-lg-8">
        <h2 className="primarycolor fw-bold">
          Built for Professional Bakery Applications
        </h2>
      </div>
    </div>

    {/* INTRO TEXT */}
    <div className="row justify-content-center mb-4">
      <div className="col-lg-9 text-center">
        <p className="fs-1-2 lh-base">
          Midd=Kitchen™ equipment supports a wide range of bakery environments, including:
        </p>
      </div>
    </div>

    {/* APPLICATION BOXES – SAME CLASSES AS ABOVE */}
    <div className="row justify-content-center">

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-bread-slice"></i>
          </span>
          <p className="mt-3 fonttitle">
            Artisan and commercial bakeries
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-industry"></i>
          </span>
          <p className="mt-3 fonttitle">
            Central production bakeries
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-cookie"></i>
          </span>
          <p className="mt-3 fonttitle">
            Patisseries and confectioneries
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-store"></i>
          </span>
          <p className="mt-3 fonttitle">
            Bakery cafés and QSR bakeries
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-hotel"></i>
          </span>
          <p className="mt-3 fonttitle">
            Institutional and hotel bakeries
          </p>
        </div>
      </div>

    </div>

    {/* FOOT LINE */}
    <div className="row justify-content-center text-center ">
      <div className="col-lg-9">
        <p className="fs-1-2 lh-base">
          Wherever consistent baking quality and controlled production are essential,
          Midd=Kitchen™ equipment is designed to perform.
        </p>
      </div>
    </div>

  </div>
</section>

<section
  className="section section--products bg-img mx-0"
  style={{ marginTop: "-50px" }}
>
  <div className="container">

    {/* TOP CONTENT */}
    <div className="wysiwyg">
      <div className="row">
        <div className="col-md-8 px-4">
          <h4 className="primarycolor">
            Engineering That Supports Consistency
          </h4>
          <p className="text-white">
            Consistent baking depends on control and stability.
            Midd=Kitchen™ equipment is engineered to deliver:

          </p>
        </div>
      </div>
    </div>

    {/* FEATURE BOXES */}
    <div className="row">

      <div className="col-lg-3 col-md-6">
        <div className="item1 h-320">
          <span className="icon text-white ft">
            <i className="fas fa-temperature-high"></i>
          </span>
          <p className="mt-3">
            <strong>Uniform Heat Distribution</strong>
            <br />
            Ensures even baking across products for consistent internal
            structure and finish.
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="item1 h-320">
          <span className="icon text-white ft">
            <i className="fas fa-layer-group"></i>
          </span>
          <p className="mt-3">
            <strong>Effective Heat Retention</strong>
            <br />
            Stone decks retain and transfer heat efficiently throughout
            the baking cycle.
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="item1 h-320">
          <span className="icon text-white ft">
            <i className="fas fa-cloud"></i>
          </span>
          <p className="mt-3">
            <strong>Controlled Steam Delivery</strong>
            <br />
            Steam is delivered at key baking stages to support oven spring
            and crust development.
          </p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="item1 h-320">
          <span className="icon text-white ft">
            <i className="fas fa-gears"></i>
          </span>
          <p className="mt-3">
            <strong>Reliable Mechanical Performance</strong>
            <br />
            Designed for stable operation, repeatable results, and efficient
            production planning.
          </p>
        </div>
      </div>

    </div>
    <div className="row">
        <div className="col-md-8 px-4">
<p className="text-white"> These factors help bakers achieve repeatable results, predictable output, and efficient production planning.
          </p>
        </div>
        </div>

  </div>
</section>

<section className="section section--products bg-white py-5">
  <div className="container">

    {/* SECTION TITLE */}
    <div className="row justify-content-center text-center mb-4">
      <div className="col-lg-8">
        <h2 className="primarycolor fw-bold">
          Service & Support You Can Reply On
        </h2>
      </div>
    </div>

    {/* INTRO TEXT */}
    <div className="row justify-content-center mb-4">
      <div className="col-lg-9 text-center">
        <p className="fs-1-2 lh-base mb-2">
          Reliable equipment requires reliable support.
        </p>
        <p className="fs-1-2 lh-base">
          Midd=Kitchen™ customers benefit from:
        </p>
      </div>
    </div>

    {/* SUPPORT FEATURES – SAME CLASSES AS ABOVE SECTIONS */}
    <div className="row justify-content-center">

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-tools"></i>
          </span>
          <p className="mt-3 fonttitle">
            Professional installation and commissioning
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-chalkboard-teacher"></i>
          </span>
          <p className="mt-3 fonttitle">
            Operator and maintenance training
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-calendar-check"></i>
          </span>
          <p className="mt-3 fonttitle">
            Preventive maintenance programs
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-cogs"></i>
          </span>
          <p className="mt-3 fonttitle">
            Genuine spare parts availability
          </p>
        </div>
      </div>

      <div className="col-md-6 col-lg-4 mb-4">
        <div className="item item-shadow text-center h-100">
          <span className="icon text-white">
            <i className="fas fa-map-marked-alt"></i>
          </span>
          <p className="mt-3 fonttitle">
            Nationwide service coverage
          </p>
        </div>
      </div>

    </div>

    {/* FOOT NOTE */}
    <div className="row justify-content-center text-center ">
      <div className="col-lg-9">
        <p className="fs-1-2 lh-base">
          All services are supported by Middleby Celfrost India’s experienced
          service network.
        </p>
      </div>
    </div>

  </div>
</section>


<section className="section p-0 section1 bg-grey section--products m-0">
  <div className="w-98 p-0">
    <div className="row">

      {/* Left Image */}
      <div
        className="col-lg-6 p-0"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img4.webp)`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      ></div>

      {/* Right Content */}
      <div className="col-lg-6 section28">
        <div className="px-3 mt-4 mb-2 pb-2">

          <h3 className="primarycolor h1 fw-bold">
            Who Midd=Kitchen™ Is Designed For
          </h3>

          <p className="mt-3 fs-1-2 lh-base">
            Midd=Kitchen™ is designed for professionals who:
          </p>

          <ul className="list-unstyled mt-3 fs-1-2 lh-lg">
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Focus on baking quality and consistency
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Require dependable, serviceable equipment
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Operate structured bakery production environments
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Value long-term performance and support
            </li>

            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Are investing in stable and scalable bakery operations
            </li>
          </ul>

          <p className="pt-3 fw-semibold fs-1-2">
            Midd=Kitchen™ is designed to grow with your bakery.
          </p>

        </div>
      </div>

    </div>
  </div>
</section>




<section className="section section1 bg-black text-white section--products m-0">
  <div className="container">
    <div className="wysiwyg">

      <div className="row align-items-center justify-content-between pt-0">
          <h2 className="h1 fz-4 text-center text-white fw-bold mb-4" >
            Talk to a Bakery Equipment Specialist
          </h2>
        {/* Left Content */}
        <div className="col-md-6">


          <p className="mb-4 fs-1-2 lh-base">
            Selecting the right bakery equipment plays a key role in product quality and operational efficiency.
          </p>

          <ul className="list-unstyled fs-1-2 lh-lg mb-4">
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Equipment selection based on bakery type and output
            </li>
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Deck oven configuration and capacity planning
            </li>
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Workflow integration
            </li>
            <li className="pt-2">
              <span className="primarycolor fw-bold">✔ </span>
              Installation and service planning
            </li>
          </ul>

          <a
                className="btn"
                onClick={() => OpenTingleModal("freedemo")}
              >
             Request a Demo
          </a>
        </div>

        {/* Right Image */}
        <div className="col-md-5 mb-5 section23 text-center">
          <img
            className="pizzeriaimage p-0 exp-img2"
            src={`${process.env.PUBLIC_URL}/assets/uploads/middkitchen/img5.png`}
            alt="Bakery Equipment"
          />
        </div>

      </div>

    </div>
  </div>
</section>





            <div className={`tingle-modal tingle-modal--overflow ${modalVisible ? 'tingle-modal--visible' : ''}`} id="tingle-modal23">
                <button type="button" className="tingle-modal__close" id="tingle-modal__close23" onClick={() => OpenTingleModal()}>
                    <span className="tingle-modal__closeIcon">
                    </span>
                    <span className="tingle-modal__closeLabel">Close</span>
                </button>
                <div className="tingle-modal-box">
                    <div className="tingle-modal-box__content">
                        {modalType && modalType === 'freedemo' &&
                            <div id="demonstration1" className="modal-content">
                                <div className="wysiwyg">
                                    <h2>
                                        <strong>Book a Demonstration</strong>
                                    </h2>
                                </div>
                                <div className="wpcf7 js" id="wpcf7-f698-o1" lang="en-GB" dir="ltr">
                                    <div className="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form onSubmit={BookhandleSubmit} method="post" id="add_Form" className="wpcf7-form init">
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${BookFromErrors.inputFullName ? 'error' : ''}`}
                                                    name="inputFullName"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputFullName}
                                                    type="text"
                                                    id="inputFullName"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputFullName">Full Name*</label>
                                                {BookFromErrors.inputFullName && <span className="error-message">{BookFromErrors.inputFullName}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${BookFromErrors.inputNumber ? 'error' : ''}`}
                                                    name="inputNumber"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputNumber}
                                                    type="tel"
                                                    id="inputNumber"
                                                    placeholder=" "
                                                    maxLength={10}
                                                />
                                                <label className="label" htmlFor="inputNumber">Contact Number*</label>
                                                {BookFromErrors.inputNumber && <span className="error-message">{BookFromErrors.inputNumber}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${BookFromErrors.inputEmail ? 'error' : ''}`}
                                                    name="inputEmail"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputEmail}
                                                    type="email"
                                                    id="inputEmail"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputEmail">Email Address*</label>
                                                {BookFromErrors.inputEmail && <span className="error-message">{BookFromErrors.inputEmail}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text ${BookFromErrors.inputCity ? 'error' : ''}`}
                                                    name="inputCity"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputCity}
                                                    type="text"
                                                    id="inputCity"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputCity">City*</label>
                                                {BookFromErrors.inputCity && <span className="error-message">{BookFromErrors.inputCity}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-group-textarea form-label-field">
                                            <p>
                                                <textarea
                                                    onChange={handleChange}
                                                    cols="40"
                                                    rows="10"
                                                    className="wpcf7-form-control wpcf7-textarea"
                                                    name="inputMessage"
                                                    aria-invalid="false"
                                                    id="inputMessage"
                                                    value={BookFromData.inputMessage}
                                                    placeholder=" "
                                                ></textarea>
                                                <label className="label" htmlFor="inputMessage">How can we help?</label>
                                            </p>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <p>*Required </p>
                                            </div>
                                            <div className="col-5">
                                                <p>
                                                    <button
                                                        className="btn btn--secondary btn--block"
                                                        name="DemonstrationSubmit"
                                                        id="DemonstrationSubmit"
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                    >
                                                        <span>{isSubmitting ? "Please Wait..." : "Send"}</span>
                                                        <span className="icon"></span>
                                                    </button>

                                                </p>
                                            </div>
                                        </div>
                                        <div className="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        }

                        {modalType && modalType === 'downloadbroucher' &&
                            <div id="demonstration2" className="modal-content">
                                <div className="wysiwyg">
                                    <h2>
                                        <strong>Download your 2024 brochure</strong>
                                    </h2>
                                </div>
                                <div className="wpcf7 js" id="wpcf7-f698-o2" lang="en-GB" dir="ltr">
                                    <div className="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form onSubmit={DownloadhandleSubmit} method="post" id="add_Form2" className="wpcf7-form init" aria-label="Contact form" noValidate="novalidate" data-status="init">
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    size="40"
                                                    onChange={DownloadhandleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${DownloadFromErrors.inputFullName1 ? 'error' : ''}`}
                                                    name="inputFullName1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputFullName1}
                                                    type="text"
                                                    id="inputFullName1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputFullName1">Full Name*</label>
                                                {DownloadFromErrors.inputFullName1 && <span className="error-message">{DownloadFromErrors.inputFullName1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${DownloadFromErrors.inputNumber1 ? 'error' : ''}`}
                                                    name="inputNumber1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputNumber1}
                                                    type="tel"
                                                    id="inputNumber1"
                                                    placeholder=" "
                                                    maxLength={10}
                                                />
                                                <label className="label" htmlFor="inputNumber1">Contact Number*</label>
                                                {DownloadFromErrors.inputNumber1 && <span className="error-message">{DownloadFromErrors.inputNumber1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${DownloadFromErrors.inputEmail1 ? 'error' : ''}`}
                                                    name="inputEmail1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputEmail1}
                                                    type="email"
                                                    id="inputEmail1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputEmail1">Email Address*</label>
                                                {DownloadFromErrors.inputEmail1 && <span className="error-message">{DownloadFromErrors.inputEmail1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    size="40"
                                                    className="wpcf7-form-control wpcf7-text"
                                                    name="companyName1"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.companyName1}
                                                    type="text"
                                                    id="companyName1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="companyName1">Company Name</label>
                                                {DownloadFromErrors.companyName1 && <span className="error-message">{DownloadFromErrors.companyName1}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-label-field">
                                            <p>
                                                <select
                                                    id="brochure"
                                                    name="brochure"
                                                    onChange={DownloadhandleChange}
                                                    className={`wpcf7-form-control ${DownloadFromErrors.brochure ? 'error' : ''}`}
                                                    value={DownloadFromData.brochure}
                                                >
                                                    <option value="">Select Brochure*</option>
                                                    {renderCatalouge()}
                                                </select>
                                                <label className="label" htmlFor="brochure">Brochure*</label>
                                                {DownloadFromErrors.brochure && <span className="error-message">{DownloadFromErrors.brochure}</span>}
                                            </p>
                                        </div>
                                        <div className="form-group form-group-textarea form-label-field">
                                            <p>
                                                <input
                                                    onChange={DownloadhandleChange}
                                                    className="wpcf7-form-control wpcf7-text"
                                                    name="inputMessage1"
                                                    aria-invalid="false"
                                                    value={DownloadFromData.inputMessage1}
                                                    id="inputMessage1"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputMessage1">City</label>
                                                {DownloadFromErrors.inputMessage1 && <span className="error-message">{DownloadFromErrors.inputMessage1}</span>}
                                            </p>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <p>*Required </p>
                                            </div>
                                            <div className="col-5">
                                                <p>
                                                    <button
                                                        className="btn btn--secondary btn--block"
                                                        id="DownloadBrochureSubmit"
                                                        name="DownloadBrochureSubmit"
                                                        type="submit"
                                                        disabled={isDownloadSubmitting}
                                                    >
                                                        <span>{isDownloadSubmitting ? "Please Wait..." : "Download"}</span>
                                                        <span className="icon"></span>
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}